import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'
const renderIcon = (color: string) => (
    <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.2249 6.16955C20.5455 6.43185 20.5928 6.90437 20.3305 7.22495L11.3305 18.225C11.1888 18.3981 10.9772 18.499 10.7534 18.5C10.5296 18.501 10.3171 18.4021 10.1739 18.2302L5.17385 12.2302C4.90868 11.912 4.95167 11.439 5.26988 11.1739C5.58809 10.9087 6.06101 10.9517 6.32618 11.2699L10.7447 16.5721L19.1696 6.27509C19.4318 5.95451 19.9044 5.90726 20.2249 6.16955Z'
        fill={color}
    />
)

export const Checked: React.FC<IconProps> = ({ color, size }) => <IconWrapper {...{ size, color, renderIcon }} />
